import React from 'react'
import styled, { StyledProps } from 'styled-components'

const Wrapper = styled.div<StyledProps<{ area: string }>>`
  grid-area: ${({ area }) => area};
`

export const GridArea: React.FC<{ area: string; children?: React.ReactNode }> & {
  ofType<T extends string>(): React.FC<{ area: T }>
} = ({ area, children }) => {
  return <Wrapper area={area}>{children}</Wrapper>
}

GridArea.ofType = function ofType<T extends string>(): React.FC<{ area: T }> {
  const Component: React.FC<{ area: T }> = ({ area, children }) => <Wrapper area={area}>{children}</Wrapper>
  Component.displayName = 'GridArea'
  return Component
}
